/**
 * DevExtreme (esm/renovation/ui/scheduler/workspaces/base/group_panel/cell_props.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var GroupPanelCellProps = {
    id: 0,
    text: "",
    data: Object.freeze({
        id: 0
    }),
    className: ""
};
